import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component, default as React } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Media } from 'reactstrap';
import { default as defaultImage, default as placeholderImage } from '../../assets/images/placeholder-sm.png';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import OptionHelper from '../../helpers/OptionHelper';
import ParamHelper from '../../helpers/ParamHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';
import ItemName from './ItemName';
import Rating from './Rating';
//import defaultImage from "../../assets/static/default_image.png";

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      options: [],
      errors: [],
      quantity: 1,
      comment: ''
    };
  }

  componentDidMount() {
    let location = window.location.href;
    let itemId = ParamHelper.getItemIdInURL(location);
    if (parseInt(itemId) === this.props.item.menu_id) {
      this.props.onItemClick();
    }
  }

  toggleModal() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  getBorderClass(itemId, reviewAble, selectedItems, quantity) {
    if (reviewAble) {
      if (selectedItems.find((item) => parseInt(item.menu_id, 10) === parseInt(itemId, 10)))
        return 'item-with-quantity';
    } else if (quantity > 0) return 'item-with-quantity';
    return '';
  }

  isChecked(item) {
    return (
      this.props.selectedItems &&
      !!this.props.selectedItems.find((i) => parseInt(item.menu_id, 10) === parseInt(i.menu_id, 10))
    );
  }

  onCheckboxChange(item) {
    if (this.isChecked(item)) return this.props.onRemoveItem(item);
    this.props.onSelectItem(item);
  }

  firebaseEvent(eventName) {
    let item = this.props.item;
    let locationId = this.props._location.locationId;

    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.ITEM.GROUP_NAME,
      locationId,
      itemId: item.menu_id
    });
  }

  increment() {
    this.setState({ quantity: this.state.quantity + 1 });
  }

  decrement() {
    if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  }

  render() {
    let { item, _location, reviewAble, selectedItems } = this.props;
    let quantity = CartService.getQuantityFor(item, _location.loc_id);
    let borderClass = this.getBorderClass(item.menu_id, reviewAble, selectedItems, quantity);
    const disabledClass = item.menu_status === 2 || (_location.is_homecheff && item.daily_limit !== null && item.daily_limit <= 0) ? 'disabled-item' : '';

    const originalPrice = OptionHelper.optionsTotal(
      item,
      this.state.options,
      this.state.quantity,
      item.Portion?.PortionSizes[0]
    );
    const discountedPrice = item.discounts
      ? item.discounts.discountAmountType ===
        CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED
        ? originalPrice - item.discounts.discountAmount
        : originalPrice - (originalPrice * item.discounts.discountAmount) / 100
      : originalPrice;
    const class_name = 'grid-items-item';
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';

    if (this.props.grid_layout === 'old') {
      return (
        <React.Fragment>
          <Media
            className={
              !item.menu_photo && !item.menu_description
                ? `listmenu item item-lower-height card-color  ${borderClass}`
                : `listmenu item card-color  ${borderClass}`
            }
            style={{
              borderLeftColor: `var(--card-color)`
            }}
          >
            <div style={{ width: '100%' }}>
              <div className={`row g-0 ${disabledClass}`}>
                {item.menu_photo && [
                  <div className="col-8 col-md-9 pe-1" key="name">
                    <ItemName
                      grid_layout={this.props.grid_layout}
                      reviewAble={this.props.reviewAble}
                      isChecked={this.isChecked(item)}
                      categorydailyLimit={this.props.dailyLimitCategory}
                      itemDailyLimit={item.daily_limit}
                      onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                      quantity={quantity}
                      item={item}
                      name={item?.menu_name}
                      settings={this.props.locationSettings}
                      _location={this.props._location}

                    />
                    <div className="f3 item-description card-subtitle-color">{item.menu_description}</div>
                    <div
                      className={
                        item.menu_photo !== '' && item.menu_description === ''
                          ? 'f3 item-price card-font-color item-price-without-description'
                          : 'f3 item-price card-font-color'
                      }
                    >
                      {originalPrice === discountedPrice ? (
                        <span className='card-font-color'>
                          {ViewHelper.toCurrency(
                            originalPrice,
                            _location.currency,
                            _location.decimal_places
                          )}
                        </span>
                      ) : (
                        <>
                          <span className="font-color-dark font-weight-bold  card-font-color">
                            {ViewHelper.toCurrencyWithZero(
                              discountedPrice,
                              _location.currency,
                              _location.decimal_places
                            )}
                          </span>
                          <span className="text-decoration-line-through font-color-grey ms-1 card-font-color">
                            {ViewHelper.toCurrency(
                              originalPrice,
                              _location.currency,
                              _location.decimal_places
                            )}
                          </span>
                        </>
                      )}{' '}
                      {item.menu_status === 2 ? (
                        <>
                          &nbsp;
                          <span className="card-error-color">
                            <FontAwesomeIcon
                              style={{ fontSize: '0.25rem' }}
                              className="ml-75 mr-75 align-middle"
                              size={'xs'}
                              icon={faCircle}
                            />{' '}
                            Item Unavailable
                          </span>{' '}
                        </>
                      ) : (
                        ''
                      )}
                      {_location.is_homecheff ? (
                        (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                      ) : ''}
                    </div>
                  </div>,
                  <div className="col-md-3 col-4" key="rating/image">
                    <div className="item-image-rating-container old-image">
                      <LazyLoadImage
                        width="90px"
                        height="90px"
                        placeholderSrc={placeholderImage}
                        effect="blur"
                        className="item-image"
                        src={ImageHelper.getImageURL(item.menu_photo, '?func=crop&w=300&h=300')}
                        alt={item?.menu_alt ? item.menu_alt : item?.menu_name}

                      />
                      <Rating grid_layout={this.props.grid_layout} item={item} settings={this.props.locationSettings} />
                    </div>
                  </div>
                ]}
                {!item.menu_photo && [
                  item.ratable && item.overall_rating > 0 ? (
                    [
                      <div className="col-8 col-md-9 pe-1" key="name">
                        <ItemName
                          grid_layout={this.props.grid_layout}
                          reviewAble={this.props.reviewAble}
                          isChecked={this.isChecked(item)}
                          categorydailyLimit={this.props.dailyLimitCategory}
                          itemDailyLimit={item.daily_limit}
                          onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                          quantity={quantity}
                          item={item}
                          name={item?.menu_name}
                          settings={this.props.locationSettings}
                          _location={this.props._location}

                        />
                        <div className="f3 item-description card-subtitle-color">{item.menu_description}</div>
                        <div
                          className={
                            item.menu_photo !== '' && item.menu_description === ''
                              ? 'f3 item-price item-price-without-description'
                              : 'f3 item-price '
                          }
                        >
                          {originalPrice === discountedPrice ? (
                            <span className='card-font-color'>
                              {ViewHelper.toCurrency(
                                originalPrice,
                                _location.currency,
                                _location.decimal_places
                              )}
                            </span>
                          ) : (
                            <>
                              <span className="font-color-dark font-weight-bold card-font-color card-font-color">
                                {ViewHelper.toCurrencyWithZero(
                                  discountedPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                              <span className="text-decoration-line-through card-subtite-color ml-1">
                                {ViewHelper.toCurrency(
                                  originalPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                            </>
                          )}{' '}
                          {item.menu_status === 2 ? (
                            <>
                              &nbsp;
                              <span className="card-error-color">
                                <FontAwesomeIcon
                                  style={{ fontSize: '0.25rem' }}
                                  className="ml-75 mr-75 align-middle"
                                  size={'xs'}
                                  icon={faCircle}
                                />{' '}
                                Item Unavailable
                              </span>{' '}
                            </>
                          ) : (
                            ''
                          )}
                          {_location.is_homecheff ? (
                            item.daily_limit < 5 && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                          ) : ''}
                        </div>
                      </div>,
                      <div className="col-md-3 col-4" key="rating/image">
                        <div className="item-image-rating-container">
                          <Rating grid_layout={this.props.grid_layout} item={item} settings={this.props.locationSettings} />
                        </div>
                      </div>
                    ]
                  ) : (
                    <div className="col-12 pe-1" key="name">
                      <ItemName
                        grid_layout={this.props.grid_layout}
                        reviewAble={this.props.reviewAble}
                        isChecked={this.isChecked(item)}
                        categorydailyLimit={this.props.dailyLimitCategory}
                        itemDailyLimit={item.daily_limit}
                        onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                        quantity={quantity}
                        item={item}
                        name={item?.menu_name}
                        _location={this.props._location}
                      />
                      <div className="f3 item-description card-subtitle-color" key="description">
                        {item.menu_description}
                      </div>
                      <div
                        className={
                          item.menu_photo !== '' && item.menu_description === ''
                            ? 'f3 item-price card-font-color item-price-without-description'
                            : 'f3 item-price card-font-color'
                        }
                        key="price"
                      >
                        {originalPrice === discountedPrice ? (
                          <span className='card-font-color'>
                            {ViewHelper.toCurrency(
                              originalPrice,
                              _location.currency,
                              _location.decimal_places
                            )}
                          </span>
                        ) : (
                          <>
                            <span className="font-color-dark font-weight-bold card-font-color">
                              {ViewHelper.toCurrencyWithZero(
                                discountedPrice,
                                _location.currency,
                                _location.decimal_places
                              )}
                            </span>
                            <span className="text-decoration-line-through font-color-grey ms-1">
                              {ViewHelper.toCurrency(
                                originalPrice,
                                _location.currency,
                                _location.decimal_places
                              )}
                            </span>
                          </>
                        )}{' '}
                        {item.menu_status === 2 ? (
                          <>
                            &nbsp;
                            <span className="card-error-color">
                              <FontAwesomeIcon
                                style={{ fontSize: '0.25rem' }}
                                className="ml-75 mr-75 align-middle"
                                size={'xs'}
                                icon={faCircle}
                              />{' '}
                              Item Unavailable
                            </span>{' '}
                          </>
                        ) : (
                          ''
                        )}
                        {_location.is_homecheff ? (
                          (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                        ) : ''}
                      </div>
                    </div>
                  )
                ]}
              </div>
            </div>
          </Media>
        </React.Fragment>
      );
    } else if (this.props.grid_layout !== 'old') {
      return (
        <React.Fragment>
          {this.props.grid_layout === 'default' ? (
            <Media
              className={
                !item.menu_photo && !item.menu_description
                  ? `listmenu ${class_name} item item-lower-height item-min-height card-color ${borderClass}`
                  : `listmenu item ${class_name} ${borderClass} item-max-height card-color`
              }
              style={{
                borderLeftColor: `${this.props.locationSettings?.basecolor}`
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <div
                  className={
                    item.menu_photo !== ''
                      ? `row g-0 ${disabledClass} item-with-min-height`
                      : `row g-0 ${disabledClass}`
                  }
                >
                  {item.menu_photo && [
                    <div className="col-8 col-md-9 pe-1" key="name">
                      <ItemName
                        grid_layout={this.props.grid_layout}
                        parent_index={this.props.parent_index}
                        child_index={this.props.child_index}
                        reviewAble={this.props.reviewAble}
                        isChecked={this.isChecked(item)}
                        onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                        quantity={quantity}
                        item={item}
                        name={item?.menu_name}
                        settings={this.props.locationSettings}
                        _location={this.props._location}
                      />
                      {item.menu_description !== '' && _location.quick_description === 1 && (
                        <div
                          className={
                            item.menu_status === 2
                              ? 'f3 item-description-new '
                              : 'f3 item-description '
                          }
                          key="description"
                        >
                          <h2 className='card-subtitle-color'>{item.menu_description}</h2>
                        </div>
                      )}
                      <div className="price-view">
                        <div
                          className={
                            item.menu_photo !== '' && item.menu_description === ''
                              ? 'f3 item-price card-font-color'
                              : 'f3 item-price card-font-color'
                          }
                        >
                          {originalPrice === discountedPrice ? (
                            <>
                              <span className='card-font-color'>
                                {ViewHelper.toCurrency(
                                  originalPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                              {item.menu_status === 2 ? (
                                <>
                                  <span className="card-error-color">
                                    &nbsp;
                                    <FontAwesomeIcon
                                      style={{ fontSize: '0.25rem' }}
                                      className="ml-75 mr-75 align-middle"
                                      size={'xs'}
                                      icon={faCircle}
                                    />{' '}
                                    Item Unavailable
                                  </span>{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {_location.is_homecheff && item.daily_limit !== null ? (
                                (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                              ) : ''}

                            </>
                          ) : (
                            <>
                              <span className="font-color-dark font-weight-bold card-font-color">
                                {ViewHelper.toCurrencyWithZero(
                                  discountedPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                              <span className="text-decoration-line-through card-subtite-color ml-1">
                                {ViewHelper.toCurrency(
                                  originalPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                              {item.menu_status === 2 ? (
                                <>
                                  <span className="font-danger">
                                    &nbsp;
                                    <FontAwesomeIcon
                                      style={{ fontSize: '0.25rem' }}
                                      className="ml-75 mr-75 align-middle"
                                      size={'xs'}
                                      icon={faCircle}
                                    />{' '}
                                    Item Unavailable
                                  </span>{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {_location.is_homecheff && item.daily_limit !== null ? (
                                (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                              ) : ''}
                            </>
                          )}
                        </div>
                      </div>
                    </div>,
                    <div className="col-md-3 col-4" key="rating/image">
                      <div className="item-image-rating-container item-image-rating-container-custom d-flex flex-column justify-content-end">
                        {_location.quick_button && item.menu_status !== 2 && quantity === 0 ? <div className="list-add-btn" >
                          <div className='branding-btn-color list-item-add-btn ' style={{ fontWeight: 'lighter' }} onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                            <b>+</b>
                          </div>
                        </div> : ''}
                        {_location.quick_button && item.menu_status !== 2 && quantity > 0 ?
                          <div className={`list-add-item`} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                            {quantity > 0 &&
                              <div className="list-btn-decrement d-flex flex-column align-items-center" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                <span>−</span>
                              </div>
                            }
                            {quantity > 0 &&
                              <div className='primary-color primary-font-color list-input ' style={{ fontWeight: 900 }}>
                                <b>{quantity}</b>
                              </div>
                            }
                            {quantity > 0 &&

                              <div className="list-btn-increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                <span>+</span>
                              </div>
                            }
                          </div> : ''
                        }
                        <LazyLoadImage
                          placeholderSrc={placeholderImage}
                          effect="blur"
                          wrapperClassName={_location.quick_button ? `quick-btn` : ''}
                          className={_location.quick_button ? `item-image item-quick-img` : `item-image`}
                          src={
                            ImageHelper.getImageURL(item.menu_photo, '?func=crop&w=300&h=300') ||
                            defaultImage
                          }
                          alt={item?.menu_alt ? item.menu_alt : item?.menu_name}

                        />
                        <Rating grid_layout={this.props.grid_layout} quick_button={_location.quick_button} menu_photo={item.menu_photo} item={item} settings={this.props.locationSettings} />

                      </div>
                    </div>
                  ]}
                  {!item.menu_photo && [
                    item.ratable && item.overall_rating > 0 ? (
                      [
                        <div className="col-12 col-md-12 pe-1" key="name">
                          <ItemName
                            grid_layout={this.props.grid_layout}
                            parent_index={this.props.parent_index}
                            child_index={this.props.child_index}
                            reviewAble={this.props.reviewAble}
                            isChecked={this.isChecked(item)}
                            onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                            quantity={quantity}
                            item={item}
                            name={item?.menu_name}
                            settings={this.props.locationSettings}
                            _location={this.props._location}
                          />
                          {item.menu_description !== '' && _location.quick_description === 1 && (
                            <div
                              className={
                                item.menu_status === 2
                                  ? 'f3 item-description-new '
                                  : 'f3 item-description '
                              }
                              key="description"
                            >
                              <h2 className='card-subtitle-color'>{item.menu_description}</h2>
                            </div>
                          )}
                          <div className='price-view'>
                            <div
                              className={
                                item.menu_description === '' ? 'f3 item-price' : 'f3 item-price '
                              }
                            >
                              {originalPrice === discountedPrice ? (
                                <span className='card-font-color'>
                                  {ViewHelper.toCurrency(
                                    originalPrice,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                              ) : (
                                <>
                                  <span className="font-color-dark font-weight-bold card-font-color">
                                    {ViewHelper.toCurrencyWithZero(
                                      discountedPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                  <span className="text-decoration-line-through card-subtite-color ml-1">
                                    {ViewHelper.toCurrency(
                                      originalPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                </>
                              )}{' '}
                              {item.menu_status === 2 ? (
                                <>
                                  &nbsp;
                                  <span className="font-danger">
                                    <FontAwesomeIcon
                                      style={{ fontSize: '0.25rem' }}
                                      className="ml-75 mr-75 align-middle"
                                      size={'xs'}
                                      icon={faCircle}
                                    />{' '}
                                    Item Unavailable
                                  </span>{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {_location.is_homecheff && item.daily_limit !== null ? (
                                (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                              ) : ''}
                            </div>
                          </div>
                        </div>,
                        <div className="item-image-rating-container item-image-rating-container-custom d-flex flex-column justify-content-end ">
                          {_location.quick_button && item.menu_status !== 2 && quantity === 0 ? <div className="list-add-btn" >
                            <div className='branding-btn-color list-item-add-btn ' style={{ fontWeight: 'lighter' }} onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                              <b>+</b>
                            </div>
                          </div> : ''}
                          {_location.quick_button && item.menu_status !== 2 && quantity > 0 ?
                            <div className={`list-add-item`} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                              {quantity > 0 &&
                                <div className="list-btn-decrement d-flex flex-column align-items-center" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                  <span>−</span>
                                </div>
                              }
                              {quantity > 0 &&
                                <div className='primary-color primary-font-color list-input ' style={{ fontWeight: 900 }}>
                                  <b>{quantity}</b>
                                </div>
                              }
                              {quantity > 0 &&

                                <div className="list-btn-increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                  <span>+</span>
                                </div>
                              }
                            </div> : ''
                          }
                          <Rating grid_layout={this.props.grid_layout} quick_button={_location.quick_button} item={item} settings={this.props.locationSettings} />
                        </div>
                      ]
                    ) : (
                      <div className="col-12 pe-1" key="name">
                        <ItemName
                          grid_layout={this.props.grid_layout}
                          parent_index={this.props.parent_index}
                          child_index={this.props.child_index}
                          reviewAble={this.props.reviewAble}
                          isChecked={this.isChecked(item)}
                          onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                          quantity={quantity}
                          item={item}
                          name={item?.menu_name}
                          _location={this.props._location}
                        />
                        {item.menu_description !== '' && _location.quick_description === 1 && (
                          <div
                            className={
                              item.menu_status === 2
                                ? 'f3 item-description-new '
                                : 'f3 item-description '
                            }
                            key="description"
                          >
                            <h2 className='card-subtitle-color'>{item.menu_description}</h2>
                          </div>
                        )}
                        <div className="price-view">
                          <div
                            className={
                              item.menu_description === ''
                                ? 'f3 d-flex align-items-center item-price item-price-column-space card-font-color'
                                : 'f3 item-price card-font-color'
                            }
                            key="price"
                          >
                            {originalPrice === discountedPrice ? (
                              <span className='card-font-color'>
                                {ViewHelper.toCurrency(
                                  originalPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                            ) : (
                              <>
                                <span className="font-color-dark font-weight-bold card-font-color">
                                  {ViewHelper.toCurrencyWithZero(
                                    discountedPrice,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                                <span className="text-decoration-line-through card-subtite-color ml-1">
                                  {ViewHelper.toCurrency(
                                    originalPrice,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                              </>
                            )}
                            {item.menu_status === 2 ? (
                              <>
                                {item.menu_description === '' ? '' : ' '}
                                <span className="font-danger">
                                  <FontAwesomeIcon
                                    style={{ fontSize: '0.25rem' }}
                                    className="ml-75 mr-75 align-middle"
                                    size={'xs'}
                                    icon={faCircle}
                                  />{' '}
                                  Item Unavailable
                                </span>{' '}
                              </>
                            ) : (
                              ''
                            )}
                            {_location.is_homecheff && item.daily_limit !== null ? (
                              (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                            ) : ''}
                          </div>
                        </div>
                        <div className="item-image-rating-container item-image-rating-container-custom d-flex flex-column justify-content-end ">
                          {_location.quick_button && item.menu_status !== 2 && quantity === 0 ? <div className="list-add-btn" >
                            <div className='branding-btn-color list-item-add-btn ' style={{ fontWeight: 'lighter' }} onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                              <b>+</b>
                            </div>
                          </div> : ''}
                          {_location.quick_button && item.menu_status !== 2 && quantity > 0 ?
                            <div className={`list-add-item`} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                              {quantity > 0 &&
                                <div className="list-btn-decrement d-flex flex-column align-items-center" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                  <span>−</span>
                                </div>
                              }
                              {quantity > 0 &&
                                <div className='primary-color primary-font-color list-input ' style={{ fontWeight: 900 }}>
                                  <b>{quantity}</b>
                                </div>
                              }
                              {quantity > 0 &&

                                <div className="list-btn-increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                  <span>+</span>
                                </div>
                              }
                            </div> : ''
                          }
                        </div>
                      </div>
                    )
                  ]}
                </div>
              </div>
            </Media>
          ) : (
            <Media
              className={
                !item.menu_photo && !item.menu_description
                  ? `listmenu ${class_name} item item-lower-height ${borderClass} card-color`
                  : `listmenu item ${class_name} ${borderClass} card-color`
              }
              style={{
                borderLeftColor: `${this.props.locationSettings?.basecolor}`
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <div className={`item-row-section ${disabledClass}`}>
                  {item.menu_photo && [
                    <div
                      className="item-row-section-first-item d-flex flex-column"
                      key="name"
                      style={{ position: 'relative' }}
                    >
                      <ItemName
                        grid_layout={this.props.grid_layout}
                        parent_index={this.props.parent_index}
                        child_index={this.props.child_index}
                        reviewAble={this.props.reviewAble}
                        isChecked={this.isChecked(item)}
                        onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                        quantity={quantity}
                        item={item}
                        name={item?.menu_name}
                        settings={this.props.locationSettings}
                        _location={this.props._location}

                      />
                      {item.menu_description && _location.quick_description === 1 &&
                        <div
                          className={
                            item.menu_status === 2 ? 'f3 item-description-new card-subtitle-color' : 'f3 item-description card-subtitle-color description-height'
                          }
                        >
                          {item.menu_description}
                        </div>
                      }
                      <div className='mt-auto'>
                        <div
                          className={'f3 item-price'}
                          style={{
                            bottom: 10,
                            display: 'block',
                            top: 30
                          }}
                        >
                          {originalPrice === discountedPrice ? (
                            <span className="one card-font-color" style={{ paddingRight: 5 }}>
                              {ViewHelper.toCurrency(
                                originalPrice,
                                _location.currency,
                                _location.decimal_places
                              )}
                            </span>
                          ) : (
                            <>
                              <span className="font-color-dark font-weight-bold card-font-color">
                                {ViewHelper.toCurrencyWithZero(
                                  discountedPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                              <span className="text-decoration-line-through card-subtite-color ml-1">
                                {ViewHelper.toCurrency(
                                  originalPrice,
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </span>
                            </>
                          )}
                          {item.menu_status === 2 ? (
                            <>
                              &nbsp;
                              <span className="font-danger">
                                <FontAwesomeIcon
                                  style={{ fontSize: '0.25rem' }}
                                  className="ml-75 mr-75 align-middle"
                                  size={'xs'}
                                  icon={faCircle}
                                />{' '}
                                Item Unavailable
                              </span>{' '}
                            </>
                          ) : (
                            ''
                          )}
                          {_location.is_homecheff && item.daily_limit !== null ? (
                            (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                          ) : ''}

                        </div>
                        {_location.quick_button && item.menu_status !== 2 ?
                          <div className={`item-modal-add-item ${branding_btn} mt-1 ${quantity > 0 ? 'd-flex justify-content-between' : 'd-flex justify-content-center'} `} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                            {quantity > 0 &&
                              <div className="decrement" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                <span>−</span>
                              </div>
                            }
                            <div className='branding-btn-font-color' style={{ fontWeight: 900 }}>
                              <b>{quantity > 0 ? quantity : 'Add To Cart'}</b>
                            </div>
                            {quantity > 0 &&

                              <div className="increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                <span>+</span>
                              </div>
                            }
                          </div> : ''
                        }
                      </div>
                    </div>,
                    <div className="item-row-section-second-item" key="rating/image">
                      <div className="item-image-rating-container item-image-rating-container-custom">
                        <LazyLoadImage
                          width="90px"
                          height="200px"
                          placeholderSrc={defaultImage}
                          effect="blur"
                          className="item-image"
                          src={
                            ImageHelper.getImageURL(item.menu_photo, '?func=crop&w=300&h=300') ||
                            defaultImage
                          }
                          alt={item?.menu_alt ? item.menu_alt : item?.menu_name}

                        />
                        <Rating grid_layout={this.props.grid_layout} item={item} settings={this.props.locationSettings} />
                      </div>
                    </div>
                  ]}
                  {!item.menu_photo && [
                    item.ratable && item.overall_rating > 0
                      ? [
                        <div
                          className="item-row-section-first-item d-flex flex-column"
                          key="name"
                          style={{ position: 'relative' }}
                        >
                          <ItemName
                            parent_index={this.props.parent_index}
                            child_index={this.props.child_index}
                            reviewAble={this.props.reviewAble}
                            isChecked={this.isChecked(item)}
                            onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                            quantity={quantity}
                            item={item}
                            name={item?.menu_name}
                            settings={this.props.locationSettings}
                            _location={this.props._location}

                          />
                          {item.menu_description && _location.quick_description === 1 &&
                            <div
                              className={
                                item.menu_status === 2
                                  ? 'f3 item-description-new card-subtitle-color'
                                  : 'f3 item-description card-subtitle-color description-height'
                              }
                            >
                              {item.menu_description}
                            </div>
                          }
                          <div className='mt-auto'>
                            <div
                              className={'f3 item-price'}
                              style={{
                                bottom: 10,
                                display: 'block'
                              }}
                            >
                              {originalPrice === discountedPrice ? (
                                <span className="two card-font-color">
                                  {ViewHelper.toCurrency(
                                    originalPrice,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                              ) : (
                                <>
                                  <span className="font-color-dark font-weight-bold card-font-color">
                                    {ViewHelper.toCurrencyWithZero(
                                      discountedPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                  <span className="text-decoration-line-through card-subtite-color ml-1">
                                    {ViewHelper.toCurrency(
                                      originalPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                </>
                              )}{' '}
                              {item.menu_status === 2 ? (
                                <>
                                  &nbsp;
                                  <FontAwesomeIcon
                                    style={{ fontSize: '0.25rem' }}
                                    className="ml-75 mr-75 align-middle"
                                    size={'xs'}
                                    icon={faCircle}
                                  />{' '}
                                  <span className="font-danger">Item Unavailable</span>{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {_location.is_homecheff && item.daily_limit !== null ? (
                                (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                              ) : ''}
                            </div>
                            {_location.quick_button && item.menu_status !== 2 ?
                              <div className={`item-modal-add-item ${branding_btn} mt-1 ${quantity > 0 ? 'd-flex justify-content-between' : 'd-flex justify-content-center'} `} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                                {quantity > 0 &&
                                  <div className="decrement" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                    <span>−</span>
                                  </div>
                                }
                                <div className='branding-btn-font-color' style={{ fontWeight: 900 }}>
                                  <b>{quantity > 0 ? quantity : 'Add To Cart'}</b>
                                </div>
                                {quantity > 0 &&

                                  <div className="increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                    <span>+</span>
                                  </div>
                                }
                              </div> : ''
                            }
                          </div>
                        </div>,
                        <div className="item-row-section-second-item" key="rating/image">
                          <div className="item-image-rating-container item-image-rating-container-custom">
                            <LazyLoadImage
                              width="90px"
                              height="200px"
                              placeholderSrc={defaultImage}
                              className="item-image"
                              src={defaultImage}
                              effect="blur"
                              alt={item?.menu_alt ? item.menu_alt : item?.menu_name}


                            />
                            <Rating grid_layout={this.props.grid_layout} item={item} settings={this.props.locationSettings} />
                          </div>
                        </div>
                      ]
                      : [
                        <div
                          className="item-row-section-first-item d-flex flex-column"
                          key="name"
                          style={{ position: 'relative' }}
                        >
                          <ItemName
                            parent_index={this.props.parent_index}
                            child_index={this.props.child_index}
                            reviewAble={this.props.reviewAble}
                            isChecked={this.isChecked(item)}
                            onCheckboxChange={this.onCheckboxChange.bind(this, item)}
                            quantity={quantity}
                            item={item}
                            name={item?.menu_name}
                            settings={this.props.locationSettings}
                            _location={this.props._location}
                          />
                          {item.menu_description && _location.quick_description === 1 &&
                            <div
                              className={
                                item.menu_status === 2
                                  ? 'f3 item-description-new card-subtitle-color'
                                  : 'f3 item-description card-subtitle-color description-height'
                              }
                            >
                              {item.menu_description}
                            </div>
                          }
                          <div className='mt-auto'>
                            <div
                              className={'f3 item-price'}
                              style={{
                                bottom: 10,
                                display: 'block'
                              }}
                            >
                              {originalPrice === discountedPrice ? (
                                <span className="three card-font-color" style={{ paddingRight: 5 }}>
                                  {ViewHelper.toCurrency(
                                    originalPrice,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                              ) : (
                                <>
                                  <span className="font-color-dark font-weight-bold card-font-color">
                                    {ViewHelper.toCurrencyWithZero(
                                      discountedPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                  <span className="text-decoration-line-through card-subtite-color ml-1">
                                    {ViewHelper.toCurrency(
                                      originalPrice,
                                      _location.currency,
                                      _location.decimal_places
                                    )}
                                  </span>
                                </>
                              )}
                              {item.menu_status === 2 ? (
                                <>
                                  &nbsp;
                                  <FontAwesomeIcon
                                    style={{ fontSize: '0.25rem' }}
                                    className="ml-75 mr-75 align-middle"
                                    size={'xs'}
                                    icon={faCircle}
                                  />{' '}
                                  <span className="font-danger">Item Unavailable</span>{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {_location.is_homecheff && item.daily_limit !== null ? (
                                (item.daily_limit < 5 && item.daily_limit > 0) && item.daily_limit !== 0 ? <p className='m-0 card-error-color'> {item.daily_limit + ' left for today order'} </p> : item.daily_limit <= 0 ? <p className='m-0 card-error-color'>Daily Max Limit Reached</p> : ''
                              ) : ''}
                            </div>
                            {_location.quick_button && item.menu_status !== 2 ?
                              <div className={`item-modal-add-item ${branding_btn} mt-1 ${quantity > 0 ? 'd-flex justify-content-between' : 'd-flex justify-content-center'} `} onClick={(e) => { e.stopPropagation(); quantity === 0 ? this.props.addToCart(item) : e.stopPropagation() }}>
                                {quantity > 0 &&
                                  <div className="decrement" onClick={(e) => { e.stopPropagation(); this.props.removeFromCart(item) }}>
                                    <span>−</span>
                                  </div>
                                }
                                <div className='branding-btn-font-color' style={{ fontWeight: 900 }}>
                                  <b>{quantity > 0 ? quantity : 'Add To Cart'}</b>
                                </div>
                                {quantity > 0 &&

                                  <div className="increment" onClick={(e) => { e.stopPropagation(); this.props.addToCart(item) }}>
                                    <span>+</span>
                                  </div>
                                }
                              </div> : ''
                            }
                          </div>
                        </div>,
                        <div className="item-row-section-second-item" key="rating/image">
                          <div className="item-image-rating-container item-image-rating-container-custom">
                            <LazyLoadImage
                              width="90px"
                              height="200px"
                              placeholderSrc={defaultImage}
                              effect="blur"
                              className="item-image"
                              src={
                                ImageHelper.getImageURL(
                                  item.menu_photo,
                                  '?func=crop&w=3000&h=90'
                                ) || defaultImage
                              }
                              alt={item?.menu_alt ? item.menu_alt : item?.menu_name}


                            />
                          </div>
                        </div>
                      ]
                  ]}
                </div>
              </div>
            </Media>
          )}
        </React.Fragment>
      );
    }
  }
}

export default Item;
